import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const TABLE_HEADER_CELL_RESIZER_CLASS_NAME = 'TableHeaderCellResizer';

export const TABLE_HEADER_CELL_RESIZER_CLASS_SLOTS = [
	'root',
	'ellipsis',
] as const;

export type TableHeaderCellResizerClassSlot =
	(typeof TABLE_HEADER_CELL_RESIZER_CLASS_SLOTS)[number];

export interface TableHeaderCellResizerClasses {
	root: string;
	ellipsis: string;
	active: string;
}

export type TableHeaderCellResizerClassKey =
	keyof TableHeaderCellResizerClasses;

export const getTableHeaderCellResizerUtilityClass = (slot: string) =>
	generateUtilityClass(TABLE_HEADER_CELL_RESIZER_CLASS_NAME, slot);

export const tableHeaderCellResizerClasses = generateUtilityClasses<
	keyof TableHeaderCellResizerClasses
>(TABLE_HEADER_CELL_RESIZER_CLASS_NAME, ['root', 'active', 'ellipsis']);
export default tableHeaderCellResizerClasses;
